module.exports = __webpack_public_path__ + "img/animals_03_H.9e659382.jpg";